import { __ } from '@wordpress/i18n';
import { __experimentalNumberControl as NumberControl, ToggleControl } from "@wordpress/components";
import { BControlPro } from '../../../../../../../bpl-tools/ProControls';

const Controls = ({ attributes, updateObject, premiumProps }) => {

    const { carousel } = attributes;
    const { loop, isAutoPlay, autoPlayDelay, mousewheel, grabCursor } = carousel;

    return <>
        <ToggleControl className='' label={__("Loop", "slider")} checked={loop} onChange={val => updateObject("carousel", "loop", val)} />

        <ToggleControl className='mt10' label={__("Auto Play", "slider")} checked={isAutoPlay} onChange={val => updateObject("carousel", "isAutoPlay", val)} />

        {isAutoPlay && <NumberControl className='mt10' label={__("Duration", "slider")} isShiftStepEnabled={true} shiftStep={10} value={autoPlayDelay} onChange={val => updateObject("carousel", "autoPlayDelay", val)} />}

        <BControlPro className='mt10' label={__("Mouse Wheel", "slider")} checked={mousewheel} onChange={val => updateObject("carousel", "mousewheel", val)} {...premiumProps} Component={ToggleControl} />

        <BControlPro className='mt10' label={__("Grab Cursor", "slider")} checked={grabCursor} onChange={val => updateObject("carousel", "grabCursor", val)} {...premiumProps} Component={ToggleControl} />
    </>
}
export default Controls;